import React from "react";
import { Redirect, Route } from "react-router-dom";
import { SIGNIN_PATH } from "../AppRoutes";
import {
  LOCALSTORAGE_AUTH_TOKEN,
  LOCALSTORAGE_AUTH_USER,
} from "../constants/LocalStorage";

//#rbp Auth Header with Token
export function authHeader() {
  // Get Token from LocalStorage
  const authToken = loggedUserTokenDetails();
  return { Authorization: authToken };
}

export function authfileHeader() {
  // Get Token from LocalStorage
  const authToken = loggedUserTokenDetails();
  return { Authorization: authToken, "Content-Type": "multipart/form-data" };
}

//#rbp Auth Logout
export function logout(history) {
  localStorage.removeItem(LOCALSTORAGE_AUTH_TOKEN);
  localStorage.removeItem(LOCALSTORAGE_AUTH_USER);
  history.push(SIGNIN_PATH);
}

//#rbp Logged Token Details
export function loggedUserTokenDetails() {
  let authToken = localStorage.getItem(LOCALSTORAGE_AUTH_TOKEN);
  return authToken;
}

//#rbp Logged User Details
export function loggedUserDetails() {
  let sessionData = localStorage.getItem(LOCALSTORAGE_AUTH_USER);
  sessionData = JSON.parse(sessionData) || {};
  return sessionData;
}

//#rbp Authenticate Public Routes
export function PublicRoute({ component, ...rest }) {
  const authToken = loggedUserTokenDetails();
  const { role = "" } = loggedUserDetails();
  if (!authToken) return <Route {...rest} component={component} />;
  else
    return (
      <Redirect
        to={{ pathname: role === "PayGov Admin" ? "/admin" : "/dashboard" }}
      />
    );
}

//#rbp Authenticated Routes
export function ProtectedRoute({ component, ...rest }) {
  const authToken = loggedUserTokenDetails();
  if (authToken) return <Route {...rest} component={component} />;
  else return <Redirect to={{ pathname: SIGNIN_PATH }} />;
}
